import { render, staticRenderFns } from "./WorkRules.vue?vue&type=template&id=fb074f62&scoped=true"
import script from "./WorkRules.vue?vue&type=script&lang=js"
export * from "./WorkRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb074f62",
  null
  
)

export default component.exports